import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  FidelityProgramEventSource,
  ISendingFidelityProgramEventModel
} from './models/fidelity-program-event-model';

@Injectable({
  providedIn: 'root'
})
export class FidelityProgramEventService {
  private apiUrl = `${environment.baseApimUrl}/action-triggers`;

  constructor(private http: HttpClient) {}

  emitFidelityProgramEvent(
    payload: ISendingFidelityProgramEventModel
  ): Observable<void> {
    const url = `${this.apiUrl}`;
    return this.http.post<void>(url, {
      ...payload,
      source: FidelityProgramEventSource.FRONT_END
    });
  }
}
